import { app as TeamsApp, authentication as TeamsAuthentication } from "@microsoft/teams-js";
import { signInWithTeams } from "api/signIn";
import { Typography } from "components/ui/legacy/Typography";
import { LoadingSpinner } from "components/ui/LoadingSpinner";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useLoadingState } from "hooks/useLoadingState";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setCsrfToken } from "utils/csrf";

import { useStyles } from "./styles";

export const TeamsAuthWall: FC = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const { isLoading, withLoader } = useLoadingState();
  const [inTeams, setInTeams] = useState(false);
  const { isLoggedIn, reloadUser, user } = useAuthenticatedUser();
  const { t } = useTranslation();
  const classes = useStyles();

  const init = useCallback(async () => {
    try {
      await TeamsApp.initialize();
      await TeamsApp.getContext();
      setInTeams(true);

      if (!user) {
        const teamsToken = await TeamsAuthentication.getAuthToken({ resources: [], silent: true });
        const csrfToken = await signInWithTeams(teamsToken);
        setCsrfToken(csrfToken);

        await reloadUser();
      }
    } catch (_error) {
      TeamsApp.notifyFailure({ message: "Failed to authorize", reason: TeamsApp.FailedReason.AuthFailed });
      setInTeams(false);
    } finally {
      setLoaded(true);
    }
  }, [user, reloadUser]);

  useEffect(() => {
    if (!loaded && !isLoading) {
      void withLoader(init());
    }
  }, [loaded, init, isLoading, withLoader]);

  if (loaded && !inTeams) {
    return (
      <div className={classes.teamsLayout}>
        <Typography>{t("errors.request.unauthorized")}</Typography>
      </div>
    );
  }

  if (!isLoggedIn || !user) {
    return (
      <div className={classes.teamsLayout}>
        <LoadingSpinner />
      </div>
    );
  }

  return <>{children}</>;
};
